import { requestIntercomMessenger } from "../lib/intercom-client";
import { useDocsLocalization } from "./use-docs-localization";

export function IntercomContactLink({ label }: { label?: string }) {
  const { messages } = useDocsLocalization();

  return (
    <button
      className="kaleo-intercom-trigger"
      type="button"
      onClick={requestIntercomMessenger}
    >
      {label ?? messages.contactOurTeam}
    </button>
  );
}
